module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/viluxueux-341a78ca09fb8200dfa2ca1e7c4cd516.png";